module.exports = __webpack_public_path__ + "img/genoa.5cd16c65.png";